export function setRiotBarAuthState(sessionExists: boolean, gameName?: string | null, tagLine?: string) {
  // gameName can be null, no problemo! RiotBar will use the fallback player name.
  let displayName = gameName;
  if (gameName && tagLine) {
    displayName = `${gameName}#${tagLine}`;
  }

  window.RiotBar.account.setAuthState({
    isAuthenticated: sessionExists,
    name: displayName,
  });
}
